export default {
  ConversationsScroll: {
    handleScroll() {
      const scrollContainer = this.scrollContainer;
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const clientHeight = scrollContainer.clientHeight;

      // Trigger when scrolled near the bottom (with a small buffer for better UX)
      if (scrollTop + clientHeight >= scrollHeight - 1 && !this.isLoading) {
        this.loadMoreConversations();
      }
    },

    loadMoreConversations() {
      // Prevent multiple simultaneous requests
      this.isLoading = true;

      this.pushEvent('load_more_conversations', {});

      // Reset loading state after a short delay
      setTimeout(() => {
        this.isLoading = false;
      }, 20);
    },

    mounted() {
      // Inside a Fluxon scroll area the scrolling element is its viewport, not the
      // direct parent (which is the scroll area's content wrapper).
      this.scrollContainer = this.el.closest('[data-part="viewport"]') || this.el.parentElement;
      this.isLoading = false;
      this._boundHandleScroll = this.handleScroll.bind(this);
      this.scrollContainer.addEventListener('scroll', this._boundHandleScroll, { passive: true });
    },

    destroyed() {
      if (this.scrollContainer && this._boundHandleScroll) {
        this.scrollContainer.removeEventListener('scroll', this._boundHandleScroll);
      }
    },
  },
};
